import { Button, HStack, Text, Box, Select } from "@chakra-ui/react";

const PaginationControls = ({ table, totalRow }) => {
    const pageIndex = table.getState().pagination.pageIndex;
    const pageCount = table.getPageCount();
    const pageSize = table.getState().pagination.pageSize;

    const generatePageNumbers = () => {
        const totalPages = pageCount;
        const current = pageIndex;
        const maxButtons = 5;
        const pages = [];

        if (totalPages <= maxButtons + 2) {
            // Mostrar todas las páginas
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Primera página
            pages.push(0);

            const start = Math.max(1, current - 1);
            const end = Math.min(totalPages - 2, current + 1);

            if (start > 1) pages.push("left-ellipsis");

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (end < totalPages - 2) pages.push("right-ellipsis");

            // Última página
            pages.push(totalPages - 1);
        }

        return pages;
    };

    const pages = generatePageNumbers();

    return (
        <Box
            mt={4}
            display="flex"
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
            gap={4}
        >
            <Text fontSize="sm">
                Página <strong>{pageIndex + 1}</strong> de <strong>{pageCount}</strong> | Total:{" "}
                <strong>{totalRow}</strong>
            </Text>

            <HStack spacing={1} flexWrap="wrap">
                {pages.map((page, index) =>
                    typeof page === "number" ? (
                        <Button
                            key={index}
                            onClick={() => {
                                if (page !== pageIndex) {
                                    table.setPageIndex(page);
                                }
                            }}
                            isDisabled={page === pageIndex}
                            size="sm"
                            colorScheme={pageIndex === page ? "blue" : "gray"}
                            variant="solid"
                            className={`!bg-brand-500 dark:!bg-brand-400 !rounded-full ${pageIndex !== page ? 'hover:!bg-brand-600 dark:hover:!bg-brand-300 active:!bg-brand-700 dark:active:!bg-brand-200 !text-white dark:!text-white hover:scale-[0.95]' : ''}`}
                        >
                            {page + 1}
                        </Button>
                    ) : (
                        <Text key={index} px={2}>
                            ...
                        </Text>
                    )
                )}

            </HStack>

            <HStack spacing={2}>
                <Text fontSize="sm">Mostrar</Text>
                <Select
                    size="sm"
                    value={pageSize}
                    onChange={(e) => table.setPageSize(Number(e.target.value))}
                    w="auto"
                    bg="white"
                    color="gray.800"
                    borderColor="gray.300"
                    _hover={{ borderColor: "blue.400" }}
                    _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)" }}
                    _dark={{
                        bg: "gray.800",
                        color: "gray.100",
                        borderColor: "gray.600",
                        _hover: { borderColor: "blue.300" },
                        _focus: {
                            borderColor: "blue.400",
                            boxShadow: "0 0 0 1px var(--chakra-colors-blue-400)",
                        },
                    }}
                >
                    {[10, 20, 30, 40, 50].map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </Select>

                <Text fontSize="sm">resultados</Text>
            </HStack>
        </Box>
    );
};

export default PaginationControls;
